import React from 'react';
import { NotFoundRoute } from './NotFoundRoute';
import { SuspenseWrapper } from './SuspenseWrapper';
import { useGetItemIdFromRouter } from './useGetItemIdFromRoute';

const SimilarRoute: React.FC = () => {
  const itemId = useGetItemIdFromRouter();

  if (!itemId) {
    return <NotFoundRoute />;
  }

  return (
    <SuspenseWrapper>
      <AuthRequired>
        <SimilarComponent />
      </AuthRequired>
    </SuspenseWrapper>
  );
};

const SimilarComponent = React.lazy(
  () => import('../View/SimilarViewContainer')
);
const AuthRequired = React.lazy(() => import('./redirects/AuthRedirect'));

export default SimilarRoute;
